export class ChunkDownloader {
    constructor() {
        this.columns = undefined;
        this.rows = undefined;
        this.progress = [0, 0];
        this.completed = false;
        this.lastid = undefined;
        this.onStartCallback = undefined;
        this.onProgressCallback = undefined;
        this.onCompletedCallback = undefined;
    };

    download(url, data, onStartCallback = undefined, onProgressCallback = undefined, onCompletedCallback = undefined, options = undefined) {
        this.url = url;
        this.options = options;
        if (typeof (this.options) === 'undefined') {
            this.options = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                }
            };
        }
        this.postData = data;
        this.lastid = null;
        this.progress = [0, 0];
        this.rows = [];

        this.onStartCallback = onStartCallback;
        this.onProgressCallback = onProgressCallback;
        this.onCompletedCallback = onCompletedCallback;

        this._start();

        if (typeof (this.onStartCallback) === 'function') {
            this.onStartCallback(this);
        }
    };

    _start() {
        let self = this;

        let _chunk = {
            lastid: this.lastid,
        };
        this.postData._chunk = _chunk;

        this.options.body = JSON.stringify(this.postData);

        fetch(this.url, this.options)
            .then(response => {
                if (!response.ok) {
                    throw new Error(`Network Error: (${response.status}) ${response.statusText} `);
                }
                return response.json();
            })
            .then(data => {
                self._onProgress(data);
            })
            .catch(error => {
                console.log(error);
            });
    };

    _onProgress(data) {

        this.columns = data.columns;

        this.rows = [...this.rows, ...data.rows];
        this.completed = data.completed;
        this.lastid = data.lastid;

        this.progress[0] = this.rows.length;
        this.progress[1] = data.totalRecord;



        if (typeof (this.onProgressCallback) === 'function')
            this.onProgressCallback(this);

        if (this.completed && (typeof (this.onCompletedCallback) === 'function')) {
            this.onCompletedCallback(this);
        }

        if (!this.completed && typeof (this.lastid) !== 'undefined') {
            // console.log('restarting');
            this._start();
        }
    }
}
